// Muss in den jeweiligen Modulen importiert werden mit:
// import rules from '../store/rules'

export default {
	// STRING
	// EMAIL
	// URL
	// NUMBER
	requiredPositiveIntegerRule: [
		(v) => v !== "" || "Angabe zwingend",
		(v) => !isNaN(v) || "Muss eine Zahl sein",
		(v) => v % 1 === 0 || "Keine Kommastellen",
		(v) => v >= 0 || "Muss positiv sein",
	],
	requiredIntegerRule: [
		(v) => v !== "" || "Angabe zwingend",
		(v) => !isNaN(v) || "Muss eine Zahl sein",
		(v) => v % 1 === 0 || "Keine Kommastellen",
	],
};
